import { createSlice } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import {ResponseApi} from "../BaseApi";

const employeeProviderSlice = createSlice({
    name: 'employeeProvider',
    initialState: {
        getEmployeeProviderOrders: [],
        createEmployeeProviderOrder: [],
        updateEmployeeProviderOrder: [],
        detailEmployeeProviderOrder: {},
        detailsEmployeeProvider: [],
        getEmployeeProviderLists: [],
        incomingProviders: [],
        recordsProviders: [],
        createEmployeeProvider: [],
        createEmployeeProviderPre: [],
        getEmployeeProviderByPhoneNumber: {},
        getEmployeeProviderByEmail: {},
        detailEmployeeProviderEmployee: {},
        detailEmployeeProviderOrderFiles: null,
        detailEmployeeProviderVehicle: {},
        getEmployeeProviderById: {},
        updateEmployeeProviderInfo: {},
        updateEmployeeProviderCompany: {},
        getEmployeeProviderOrdersSortList: [],
        getAllPageableProvider: [],
        getAllProviderDocuments: {},
        getAllCompanybyProviderId: [],
        approveExternalDocument: null,
        getCurrentUserDocument: [],
        getAllCompanyVehiclebyId: [],
        getUserDocumentsEmployee: {},
        createToExternalEmployee: {},
        setToExternalEmployee: {},
        createEmployeeOrder: {},
        getEmployeeSupplierByItId: {},
        createSupplierOrder: null,
    },
    reducers: {
        ClearGetEmployeeProviderByPhoneNumber: (state, action) => {
            state.getEmployeeProviderByPhoneNumber = {};
        },

        ClearGetEmployeeProviderByEmail: (state, action) => {
            state.getEmployeeProviderByEmail = {};
        },

        ClearGetEmployeeSupplierByItId: (state, action) => {
            state.getEmployeeSupplierByItId = {};
        },
    },
    extraReducers: {
        'employeeProvider/getEmployeeProviderOrders/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getEmployeeProviderOrders = data;
            }
        },
        'employeeProvider/createEmployeeProviderOrders/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast(data.message);
                state.createEmployeeOrder = data;
            }
        },
        'employeeProvider/updateEmployeeProviderOrders/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast(data.message);
                state.updateEmployeeProviderOrder = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeProvider/detailsEmployeeProviderOrders/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.detailEmployeeProviderOrder = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeProvider/detailsEmployeeProviderEmployee/fulfilled': (state, action) => {
            state.detailEmployeeProviderEmployee = ResponseApi(action.payload);
        },
        'employeeProvider/downloadEmployeeProviderOrderFiles/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast(data.message);
                state.detailEmployeeProviderOrderFiles = data;
            } else if (status >= 400 && status < 500) {
                toast(data.message);
            }
        },
        'employeeProvider/detailsEmployeeProviderVehicle/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.detailEmployeeProviderVehicle = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeProvider/detailsEmployeeProvider/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.detailsEmployeeProvider = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeProvider/getEmployeeProviderLists/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getEmployeeProviderLists = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeProvider/getIncomingProvidersPaginable/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};

            if (status >= 200 && status < 300) {
                state.incomingProviders = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeProvider/getRecordsProvidersPaginable/fulfilled': (state, action) => {
            const {
                data: { data },
                status,
            } = action.payload || {};

            if (status >= 200 && status < 300) {
                state.recordsProviders = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeProvider/getEmployeeProviderOrdersSortList/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getEmployeeProviderOrdersSortList = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },

        'employeeProvider/getAllPageableProvider/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getAllPageableProvider = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        // @create provider flow start

        'employeeProvider/getGnderListProvider/fulfilled': (state, action) => {
            state.getGnderListProvider = ResponseApi(action.payload);
        },
        'employeeProvider/createEmployeeProvider/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast(data.message);
                state.createEmployeeProvider = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeProvider/EmployeeProviderPreUser/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.createEmployeeProviderPre = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        'employeeProvider/getEmployeeProviderByPhoneNumber/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getEmployeeProviderByPhoneNumber = data?.data;
            } else if (status >= 400 && status < 500) {
                toast(data.message);
            }
        },
        'employeeProvider/getEmployeeProviderByEmail/fulfilled': (state, action) => {
            state.getEmployeeProviderByEmail = ResponseApi(action.payload);
        },
        'employeeProvider/getEmployeeProviderById/fulfilled': (state, action) => {
            state.getEmployeeProviderById = ResponseApi(action.payload);
        },
        'employeeProvider/updateEmployeeProviderInfo/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast(data.message);
                state.updateEmployeeProviderInfo = data;
            }
        },
        'employeeProvider/updateEmployeeProviderCompany/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast(data.message);
                state.updateEmployeeProviderCompany = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },
        // @update provider flow end
        // @create provider flow end
        'employeeProvider/getAllProviderDocuments/fulfilled': (state, action) => {
            state.getAllProviderDocuments = ResponseApi(action.payload);
        },

        'employeeProvider/getAllCompanybyProviderId/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getAllCompanybyProviderId = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },

        'employeeProvider/approveExternalDocument/fulfilled': (state, action) => {
            state.approveExternalDocument = ResponseApi(action.payload);
        },
        'employeeProvider/getAllProviderDocument/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getCurrentUserDocument = data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },

        'employeeProvider/getAllCompanyVehiclebyId/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getAllCompanyVehiclebyId = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error(t('something_went_wrong_2'));
            }
        },

        // getUserDocumentsEmployee  for user document

        'employeeProvider/getUserDocumentsEmployee/fulfilled': (state, action) => {
            state.getUserDocumentsEmployee = ResponseApi(action.payload);
        },

        'employeeProvider/createToExternalEmployee/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.createToExternalEmployee = data;
            }
        },

        'employeeProvider/setToExternalEmployee/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                toast.success(t('set_value_successfully'));
                state.setToExternalEmployee = data;
            }
        },
        'employeeProvider/getEmployeeSupplierByItId/fulfilled': (state, action) => {
            const { data, status } = action.payload || {};
            if (status >= 200 && status < 300) {
                state.getEmployeeSupplierByItId = data?.data;
            } else if (status >= 400 && status < 500) {
                toast.error(data.message);
            }
        },
    },
});

export const {
    ClearGetEmployeeProviderByPhoneNumber,
    ClearGetEmployeeProviderByEmail,
    ClearGetEmployeeSupplierByItId,
} = employeeProviderSlice.actions;

export default employeeProviderSlice.reducer;
